module.exports = __webpack_public_path__ + "img/dp-sy-wg.02d7fedf.png";